import { isMobile } from '@growtherapy/analytics';
import { useTranslate } from '@growtherapy/i18n';

import { isSafari as isBrowserSafari } from '../../utils';
import { BlockedPermissionDescription } from '../BlockedPermissionDescription';
import { HelpModalItem } from './HelpModalItem';

export function BlockedPermissionsActionItem({
  isMobile: isMobileDevice,
  isSafari,
}: {
  isMobile: boolean;
  isSafari: boolean;
}) {
  const t = useTranslate();
  return (
    <HelpModalItem
      heading={t('telehealth-core:troubleshooting.myCameraAndMicArentWorking')}
      description={
        <div className='flex flex-col gap-4'>
          <BlockedPermissionDescription isMobile={isMobileDevice} isSafari={isSafari} />
        </div>
      }
    />
  );
}

export function BlockedPermissionsActionItemWrapper() {
  const isMobileDevice = isMobile(navigator.userAgent);
  const isSafari = isBrowserSafari();
  return <BlockedPermissionsActionItem isMobile={isMobileDevice} isSafari={isSafari} />;
}
